import {
  Box,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import AttendanceEmployeeDetail from "../components/AttendanceEmployeeDetail";

function Pill({ children, sx }) {
  return (
    <Box
      sx={{
        px: 2.5,
        py: 1.1,
        bgcolor: "secondary.50",
        borderRadius: "33px",
        boxShadow: "inset 0px 0px 3px rgba(142, 142, 159, 0.5)",
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}


export default function AsistenciaDetallePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { employeeId } = useParams();

  const employeeFromState = location.state?.employee || {};

  const employee = {
    ...employeeFromState,
    employeeId: Number(employeeFromState?.employeeId || employeeId),
  };

  return (
    <Stack
      spacing={2}
      sx={{
        p: 2,
        pb: 2,
        overflowX: "hidden",
        height: "100%",
        minHeight: 0,
      }}
    >
      <Stack
        direction="row"
        sx={{
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <IconButton
          onClick={() => navigate("/rrhh/asistencia")}
          sx={{
            width: 36,
            height: 36,
            bgcolor: "secondary.500",
            "&:hover": { bgcolor: "secondary.600" },
          }}
        >
          <ArrowBackIcon sx={{ color: "logoblanco", fontSize: 32 }} />
        </IconButton>

        <Stack sx={{ flex: 1, alignItems: "center", pr: "48px" }}>
          <Pill sx={{ bgcolor: "secondary.200" }}>
            <Typography
              sx={{
                fontSize: 18,
                fontWeight: 600,
                color: "primary.900",
              }}
            >
              Detalle de asistencia
            </Typography>
          </Pill>
        </Stack>
      </Stack>

      <AttendanceEmployeeDetail employee={employee} />
    </Stack>
  );
}